module.exports = __webpack_public_path__ + "img/seven_x.6c5d5aba.png";